import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, History } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { formatScheduledLocal } from "../../utils/terapieExtraFormat";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function TerapiaExtraStoricoDialog({
  open,
  onOpenChange,
  fascicoloId,
  terapia,
  authHeaders,
  storicoUrl,
  subtitle,
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !fascicoloId || !terapia?.id || !authHeaders) return;
    setLoading(true);
    const url =
      storicoUrl?.(fascicoloId, terapia.id) ||
      `${API_URL}/api/fascicoli-assistenziali/${fascicoloId}/terapie-extra/${terapia.id}/storico`;
    axios
      .get(url, { headers: authHeaders })
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [open, fascicoloId, terapia?.id, authHeaders, storicoUrl]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="w-5 h-5 text-blue-500" />
            Storico somministrazioni
          </DialogTitle>
          <DialogDescription>
            {subtitle || terapia?.nome || "Terapia extra"}
          </DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-blue-500" />
          </div>
        ) : items.length === 0 ? (
          <p className="text-sm text-slate-500 py-4">Nessuna somministrazione registrata.</p>
        ) : (
          <ul className="space-y-3">
            {items.map((item) => (
              <li
                key={item.id}
                className="rounded-lg border border-slate-200 p-3 bg-slate-50/80"
              >
                <p className="font-medium text-slate-900 text-sm">
                  Prevista: {formatScheduledLocal(item.scheduled_at_local || item.scheduled_at)}
                </p>
                <p className="text-xs text-slate-600 mt-1">
                  Somministrata il{" "}
                  {formatScheduledLocal(item.somministrata_at)} da{" "}
                  <span className="font-medium">{item.somministrata_da_nome}</span>
                  {item.somministrata_da_ruolo ? ` (${item.somministrata_da_ruolo})` : ""}
                </p>
                {item.note ? (
                  <p className="text-xs text-slate-500 mt-1 italic">Note: {item.note}</p>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
